import { useTranslation } from 'react-i18next'
import { Box, Button, Alert, AlertTitle } from '@mui/material'

export interface ErrorHandlerProps {
  error: Error
  reset: () => void
}

const ErrorHandler = ({ error, reset }: ErrorHandlerProps) => {
  const { t } = useTranslation()
  return (
    <Box padding={4}>
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" onClick={reset}>
            {t('error.reset')}
          </Button>
        }
      >
        <AlertTitle>{t('error.somethingWentWrong')}</AlertTitle>
        {error.message}
      </Alert>
    </Box>
  )
}

export default ErrorHandler
